import { X } from "lucide-react";
import { Sheet, SheetClose, SheetContent, SheetDescription, SheetFooter, SheetHeader, SheetTitle, SheetTrigger } from "./ui/sheet";
import { Suspense } from "react";
import Loader from "./Loader";
import { cn } from "src/lib/utils";

const CustomSheet = ({ title, description, children, footer, trigger, className }) => (
	<Sheet>
		<SheetTrigger asChild>{trigger}</SheetTrigger>
		<SheetContent
			side="right"
			className={cn(
				"tw-flex tw-flex-col tw-overflow-y-auto tw-p-0 tw-transition-all md:tw-max-w-lg lg:tw-max-w-[35.75rem] [&_.defaultClose]:tw-hidden",
				className
			)}
		>
			<SheetHeader className="tw-sticky tw-top-0 tw-z-10 tw-h-fit tw-bg-background">
				<div className="tw-flex tw-flex-row tw-items-center tw-justify-between tw-px-4 tw-py-4 tw-border-b tw-border-b-input md:tw-px-6 lg:tw-px-8">
					<div className="tw-flex-1">
						<SheetTitle className="tw-max-w-[80%] tw-text-left tw-text-lg tw-font-semibold tw-text-gray-700">{title}</SheetTitle>
						{!!description && <SheetDescription className="tw-text-left">{description}</SheetDescription>}
					</div>

					<SheetClose
						type="button"
						id="sheet-button"
						className="!tw-m-0 tw-aspect-square tw-w-fit tw-rounded-full tw-p-1 tw-flex tw-items-center tw-justify-center hover:tw-bg-accent"
					>
						<X className="tw-size-5 tw-text-black" />
					</SheetClose>
				</div>
			</SheetHeader>

			<div className="tw-flex-1 tw-px-4 tw-pb-10 @container/sheet md:tw-px-6 lg:tw-px-8 tw-grid">
				<Suspense fallback={<Loader />}>{children}</Suspense>
			</div>

			{footer && (
				<SheetFooter className="tw-sticky tw-bottom-0 tw-px-4 tw-py-4 tw-pt-4 tw-pb-8 tw-bg-background md:tw-px-6 lg:tw-px-8">
					{footer}
				</SheetFooter>
			)}
		</SheetContent>
	</Sheet>
);

export const CustomSheetWithoutTrigger = ({ title, description, children, footer, className, ...rest }) => (
	<Sheet {...rest}>
		<SheetContent
			side="right"
			className={cn(
				"tw-flex tw-flex-col tw-overflow-y-auto tw-p-0 tw-transition-all md:tw-max-w-lg lg:tw-max-w-[39.75rem] [&_.defaultClose]:tw-hidden",
				className
			)}
		>
			<SheetHeader className="tw-sticky tw-top-0 tw-z-10 tw-h-fit tw-bg-background">
				<div className="tw-flex tw-flex-row tw-items-start tw-justify-between tw-px-4 tw-py-4 tw-border-b tw-border-b-input md:tw-px-6 lg:tw-px-8">
					<div className="tw-flex-1">
						<SheetTitle className="tw-max-w-[80%] tw-text-left tw-text-lg tw-font-semibold tw-text-gray-700">{title}</SheetTitle>
						<SheetDescription className="tw-text-left">{description}</SheetDescription>
					</div>

					<SheetClose
						type="button"
						id="sheet-button"
						className="!tw-m-0 tw-aspect-square tw-w-fit tw-rounded-full tw-p-1 hover:tw-bg-accent"
					>
						<X className="tw-size-5" />
					</SheetClose>
				</div>
			</SheetHeader>

			<div className="tw-flex-1 tw-px-4 tw-pb-10 @container/sheet md:tw-px-6 lg:tw-px-8 tw-grid">
				<Suspense fallback={<Loader />}>{children}</Suspense>
			</div>

			{footer && (
				<SheetFooter className="tw-sticky tw-bottom-0 tw-px-4 tw-py-4 tw-pt-4 tw-pb-8 tw-bg-background md:tw-px-6 lg:tw-px-8">
					{footer}
				</SheetFooter>
			)}
		</SheetContent>
	</Sheet>
);

export default CustomSheet;
